/**
* Collage Image Content JS
* -----------------------------------------------------------------------------
*
* All the JS for the Collage Image Content component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'collage-image-content',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.collage-image-content__accordion-item:first-of-type .collage-image-content__accordion-btn' ).trigger( 'click' );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'collage-image-content', COMPONENT );
} )( app );
